import React from 'react';
import { Clock } from 'lucide-react';
import { isTimeSlotConflicting } from '../../services/availabilityService';
import { GOLD } from '../../constants/booking';
import { isTimeRangeAvailable, generateTimeSlots } from './bookingHelpers';

const ALL_TIME_SLOTS = generateTimeSlots();

const sectionTitleStyle = {
  fontSize: '1.25rem',
  fontWeight: '600',
  marginBottom: '1rem',
  color: '#F5F0E8',
};

export default function TimeSlotPicker({
  selectedDate,
  selectedTime,
  availableTimeSlots,
  bookedTimes,
  durationHours,
  tentativeBookingHours,
  existingBookings,
  availabilitySettings,
  loadingBookedTimes,
  onTimeSelect,
  isMobile,
}) {
  return (
    <div style={{ marginBottom: '1.5rem', flex: 1 }}>
      <h3 style={{ ...sectionTitleStyle, display: 'flex', alignItems: 'center' }}>
        <Clock size={20} style={{ marginRight: '0.5rem', color: GOLD }} />
        Select Time
        {loadingBookedTimes && (
          <span style={{ marginLeft: '0.5rem', fontSize: '0.75rem', color: '#F5F0E8' }}>Loading…</span>
        )}
      </h3>

      <div
        className="dd-time-grid"
        style={{
          display: 'grid',
          gridTemplateColumns: isMobile ? 'repeat(3, 1fr)' : 'repeat(4, 1fr)',
          gap: '0.5rem',
        }}
      >
        {ALL_TIME_SLOTS.map((time) => {
          const isBooked = bookedTimes.includes(time);
          const isRangeConflict = selectedDate ? !isTimeRangeAvailable(time, durationHours, bookedTimes) : false;
          const hasBufferConflict =
            selectedDate && availabilitySettings
              ? isTimeSlotConflicting(selectedDate, time, existingBookings, availabilitySettings.generalSettings)
              : false;
          const slotInSchedule = !selectedDate || availableTimeSlots.includes(time);
          const isDisabled = Boolean(selectedDate) && (isBooked || isRangeConflict || hasBufferConflict || !slotInSchedule);
          const isInRange = selectedTime && tentativeBookingHours.includes(time);
          const isActive = !isDisabled && (selectedTime === time || isInRange);

          return (
            <button
              key={time}
              type="button"
              onClick={() => !isDisabled && onTimeSelect(time)}
              disabled={isDisabled}
              aria-disabled={isDisabled}
              style={{
                border: isActive ? `2px solid ${GOLD}` : isDisabled ? '1px solid #374151' : '1px solid #4b5563',
                borderRadius: '0.75rem',
                padding: isMobile ? '0.5rem 0.25rem' : '0.75rem',
                backgroundColor: isActive ? GOLD : isDisabled ? '#111111' : '#1a1a1a',
                color: isActive ? '#000000' : isDisabled ? '#6b7280' : '#F5F0E8',
                cursor: isDisabled ? 'not-allowed' : 'pointer',
                fontSize: isMobile ? '0.7rem' : '0.8125rem',
                fontWeight: '600',
              }}
            >
              {time}
            </button>
          );
        })}
      </div>
    </div>
  );
}
